import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleAuthCallback } from '@/lib/auth/session';
import { isMockMode } from '@/lib/supabase';

export default function AuthCallback() {
    const navigate = useNavigate();

    useEffect(() => {
        if (isMockMode) {
            navigate('/dashboard', { replace: true });
            return;
        }

        const finalizeAuth = async () => {
            try {
                const user = await handleAuthCallback();
                if (user) {
                    navigate(user.redirectTo ?? '/courses', { replace: true });
                } else {
                    navigate('/', { replace: true });
                }
            } catch (error) {
                console.error('Finalize auth error:', error);
                navigate('/', { replace: true });
            }
        };

        finalizeAuth();
    }, [navigate]);

    return <div className="min-h-screen bg-[#0e0e0e]" aria-hidden="true" />;
}
